import { render, staticRenderFns } from "./zuimingcont.vue?vue&type=template&id=0dc3d10f&scoped=true&"
import script from "./zuimingcont.vue?vue&type=script&lang=js&"
export * from "./zuimingcont.vue?vue&type=script&lang=js&"
import style0 from "./zuimingcont.vue?vue&type=style&index=0&id=0dc3d10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3d10f",
  null
  
)

export default component.exports